<template>

	<ul class="flex h-full items-end pl-4 pb-2.5 space-x-1.5" v-if="shouldPaginate">
		<li v-if="prevUrl">
			<a class="px-4 py-2 border rounded" href="#" aria-label="Previous" rel="prev" @click.prevent="gotoLink(prevUrl)">
				<span aria-hidden="true">&laquo; </span>
			</a>
		</li>
		<li v-for="pageNumber in lastPage" :key="pageNumber" >
			<a class="px-4 py-2 border rounded" :class="{'bg-blue-400 font-semibold text-white': isSamePage(pageNumber) }" href="#" :aria-label="pageNumber" rel="" @click.prevent="gotoLink(pageUrl(pageNumber))">
				<span aria-hidden="true">{{ pageNumber }}</span>
			</a>
		</li>
		<li v-if="nextUrl">
			<a class="px-4 py-2 border rounded" href="#" aria-label="Next" rel="next" @click.prevent="gotoLink(nextUrl)">
				<span aria-hidden="true"> &raquo;</span>
			</a>
		</li>
	</ul>
</template>

<script>
export default {

	props: ['dataSet'],

	data(){
		return {
			page: 1, 
			prevUrl : false,
			nextUrl : false,
			lastPage : false,
			perPage : 5,			
		}
	},

	watch:{
		dataSet() {
			this.page = this.dataSet.current_page			
			this.prevUrl = this.dataSet.prev_page_url
			this.nextUrl = this.dataSet.next_page_url
			this.lastPage = this.dataSet.last_page
			this.perPage = this.dataSet.per_page
		},


	},

	computed: {
		shouldPaginate(){
			return !! this.prevUrl || !! this.nextUrl
		},

	},

	methods: {
		broadcast(link){					
			return this.$emit('changed', link);
		},



		gotoLink(link) {
			this.broadcast(link)
		},

		pageUrl(page) {
			return this.dataSet.path+'?page=' + page
		},

		parsePage(link){
			
			let urlParams = new URLSearchParams(new URL(link).search);

			return urlParams.get('page')  

		},

		isSamePage(page){
			return page == this.page
		}
	}
};
</script>

<!--<style>-->
<!--.pagination{-->
<!--  display: table;-->
<!--  margin: 30px auto;-->
<!--}-->

<!--.pagination>li:first-child>a,-->
<!--.pagination>li:first-child>span,-->
<!--.pagination>li:last-child>a,-->
<!--.pagination>li:last-child>span{-->
<!--  border-radius: 50%;-->
<!--}-->

<!--.pagination>li>a, .pagination>li>span{-->
<!--  border: 1px solid #d7d7d7;-->
<!--  color:#aeaeae;-->
<!--  font-size: 14px;-->
<!--  height: 34px;-->
<!--  width: 34px;-->
<!--  margin:2px;-->
<!--  border-radius: 50%;-->
<!--  transition: 350ms ease all;-->
<!--}-->

<!--.pagination-sm>li>a,-->
<!--.pagination-sm>li>span{-->
<!--  height: 30px;-->
<!--  width: 30px;-->
<!--  font-size: 12px;-->
<!--}-->

<!--.pagination-lg>li>a,-->
<!--.pagination-lg>li>span{-->
<!--  height: 40px;-->
<!--  width: 40px;-->
<!--}-->

<!--.pagination>.active>a,-->
<!--.pagination>.active>a:focus,-->
<!--.pagination>.active>a:hover,-->
<!--.pagination>.active>span,-->
<!--.pagination>.active>span:focus,-->
<!--.pagination>.active>span:hover{-->
<!--  background-color: #20c5f7;-->
<!--  border-color: #20c5f7;-->
<!--}-->

<!--.pagination>li>a:focus,-->
<!--.pagination>li>a:hover,-->
<!--.pagination>li>span:focus,-->
<!--.pagination>li>span:hover{-->
<!--  background-color: #f7f7f7;-->
<!--  color: #1a2b51;-->
<!--}-->

<!--</style>-->
